"use client";

import Footer from "../components/footer";
import Header, { HeaderContext } from "../components/header";
import { fulldays_text } from "../translation";
import { useContext } from "react";

import { Helmet } from "react-helmet";


const gallery = [
    {pdf: "/paquetes/dosgardeniastours-FD-ICA_PARACAS.pdf", url:"/images/full-days/dosgardeniastours-ica.jpeg", name:"Ica - Paracas"},
    {pdf: "/paquetes/dosgardeniastours-FD-CHANCAY.pdf", url:"/images/full-days/dosgardeniastours-chancay.jpeg", name:"Chancay - Huaral"},
    {pdf: "/paquetes/dosgardeniastours-FD-ANTIOQUIA.pdf", url:"/images/full-days/dosgardeniastours-antioquia.jpeg", name:"Antioquía"},
    {pdf: "/paquetes/dosgardeniastours-FD-CHURIN.pdf", url:"/images/full-days/dosgardeniastours-churin.jpeg", name:"Churín"},
    {pdf: "/paquetes/dosgardeniastours-FD-SAN-MATEO-DE-OTAO.pdf", url:"/images/full-days/dosgardeniastours-sanmateo.jpeg", name:"San Mateo de Otao"},
    {pdf: "/paquetes/dosgardeniastours-FD-LUNAHUANA.pdf", url:"/images/full-days/dosgardeniastours-lunahuana.jpeg", name:"Lunahuaná"},
];

export default function FullDays() {
    const { lang } = useContext(HeaderContext);
    const url = 'https://www.dosgardeniastours.com/fulldays'

    return (
    <>
      <Header />
      <Helmet>
                <title>FullDays Dos Gardenias Tours </title>
                <link rel="canonical" href={url} />                
                <meta name="description" content={'Aventura de un día'} />
                <meta property="og:site_name" content="DosGardeniasTours" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={url} />
                <meta property="og:title" content='FullDays Dos Gardenias Tours' />
                <meta property="og:description" content={'Aventura de un día'} />              
            
      </Helmet>

      <main className="overflow-hidden">

        {/* HERO */}

        <section className="relative h-screen flex items-center justify-center">

          <img
            src="/images/full-days/hero.png"
            alt="Full Day Tours"
            fill
            priority
            className="hidden md:block object-cover h-full  w-full"
          />
          <img
            src="/images/full-days/hero-mobile.png"
            alt="Full Day Tours"
            fill
            priority
            className="block md:hidden object-cover w-full h-full "
          />

          <div className="absolute inset-0 bg-black/45" />

          <div className="absolute z-10 text-center text-white px-6 max-w-5xl    ">

            <p className="uppercase tracking-[5px] mb-6 text-sm">
              DOS GARDENIAS TOURS
            </p>

            <h1 className="font-ivymode text-5xl md:text-7xl leading-tight whitespace-pre">
              {fulldays_text.title[lang]}
            </h1>

            <p className="mt-8 text-lg md:text-xl max-w-3xl mx-auto">
                {fulldays_text.subtitle[lang]}
            </p>

            <div className="mt-10 flex flex-col md:flex-row flex-wrap gap-4 items-center md:justify-center ">

              <a
                target="_blank"
                rel="noreferrer" 
                href="/paquetes/dosgardeniastours-paquetes-fulldays-2026.pdf"
                className="w-[15rem] rounded-full px-14 md:px-8 py-4  shadow-lg hover:shadow-xl bg-white 
                text-dggreen hover:text-white hover:bg-dggreen text-lg md:text-2xl font-poppins"
              >
                {fulldays_text.catchy_pdf_button[lang]}
              </a>
              <a
                target="_blank"
                rel="noreferrer" 
                href="/paquetes/dosgardeniastours-tarifario.pdf"
                className="w-[15rem] rounded-full px-14 md:px-8 py-4  shadow-lg hover:shadow-xl hover:bg-white 
                hover:text-dggreen text-white bg-dggreen text-lg md:text-2xl font-poppins "
              >
                {fulldays_text.prices[lang]}
              </a>

            </div>

          </div>

        </section>

        {/* TOURS */}

        

        
        {/* GALLERY */}

        <section className="py-24 bg-[#F8F6F2]">

          <div className="container mx-auto px-6">

            <h2 className="font-ivymode text-center text-5xl mb-16">
                {fulldays_text.gallery[lang]}
            </h2>

            <div className="grid md:grid-cols-3 gap-6 font-poppins">

              {gallery.map((item, i) => (

                <div
                  key={i}
                  className="relative h-80 rounded-3xl overflow-hidden group"
                >
                    <a href={item.pdf} target="_blank" rel="noreferrer" >
                      <p className="pt-2 h-12  bg-white  text-center text-2xl">{item.name}</p>
                      <img
                          src={item.url}
                          alt=""
                          fill
                          className="object-cover object-center group-hover:scale-105 transition duration-500"
                      />

                    </a>
                
                    {/* <div className="absolute inset-0 bg-black/25 group-hover:bg-black/40 transition" /> */}

                </div>

              ))}

            </div>

          </div>

        </section>

        {/* CTA */}

        

      </main>

      <Footer />
    </>
  );
}